/**
 * Which week of «Поделиться окнами» the «Неделя» view is showing: 'this'
 * (today to Sunday), 'next', or null for any other week — the sheet then
 * opens on «Эта неделя». Dates are the coach's calendar dates, 'YYYY-MM-DD'.
 */
const addDays = (key: string, n: number) =>
  new Date(Date.parse(`${key}T12:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);
const mondayOf = (key: string) => addDays(key, -((new Date(`${key}T12:00:00Z`).getUTCDay() + 6) % 7));

export function storyWeekFor(viewedMonday: string, todayKey: string): 'this' | 'next' | null {
  const thisMonday = mondayOf(todayKey);
  if (viewedMonday === thisMonday) return 'this';
  if (viewedMonday === addDays(thisMonday, 7)) return 'next';
  return null;
}
